


export const isDexKitSwapDomain = () => {
    return window.location.hostname === "swap.dexkit.com";
  // return window.location.hostname === "localhost";
}